const VerticalDividerLine = () => (
  <span style={{ 
    borderLeft: '1px solid black', 
    height: '20px', 
    margin: '0 8px'
  }}  />
);

export default VerticalDividerLine;